var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.8 17C29.723 17 24 22.76 24 29.88c0 9.66 12.8 23.92 12.8 23.92s12.8-14.26 12.8-23.92C49.6 22.76 43.877 17 36.8 17Z",
    fill: "#007934",
    stroke: "#fff",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 22.5c-4.14 0-7.5 3.36-7.5 7.5 0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5 0-4.14-3.36-7.5-7.5-7.5Zm-.75 11.25v-4.5h1.5v4.5h-1.5Zm0-7.5v1.5h1.5v-1.5h-1.5Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31786_50163"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(22 15)",
    d: "M0 0h29v41H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinLocation);
export default __webpack_public_path__ + "static/media/pin_location.4955f93633e8602ba7970653f9830c04.svg";
export { ForwardRef as ReactComponent };